import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/i18n'

Vue.use(Router)

const routes = [
  {
    path: '/:lang(en|th)',
    component: () => import('@/views/PageController'),
    children: [
      {
        path: '',
        name: 'business',
        component: () => import('@/views/Business')
      },
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/Home')
      },
      {
        path: 'setting',
        name: 'setting',
        component: () => import('@/views/Setting')
      },
      {
        path: 'channel',
        name: 'channel',
        component: () => import('@/views/ManageChannel')
      },
      {
        path: 'richmenu',
        component: {
          render: (h) => h('router-view')
        },
        children: [
          {
            path: '',
            name: 'LineRichmenu',
            component: () => import('@/views/LineRichmenu')
          },
          {
            path: 'analytic/:richmenuid',
            name: 'LineRichmenuAnalytic',
            component: () => import('@/views/LineRichmenuAnalytic')
          },
          {
            path: 'maker',
            name: 'LineRichmenuManager',
            component: () => import('@/views/LineRichmenuManager')
          }
        ]
      },
      {
        path: 'contactus',
        name: 'ContactUs',
        component: () => import('@/views/Contact-us')
      }
    ]
  },
  {
    path: '/',
    redirect: '/th'
  }
]

const router = new Router({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  const lang = to.params.lang || 'th'
  if (lang !== i18n.locale) {
    i18n.locale = lang
  }
  next()
})

export default router
